import api from './client';

export const tagsApi = {
  list: (category) => api.get('/tags', { params: { category } }).then(r => r.data),
  create: (data) => api.post('/tags', data).then(r => r.data),
  batchForRecords: (recordIds) =>
    api.post('/tags/batch', { record_ids: recordIds }).then(r => r.data),
  delete: (id) => api.delete('/tags/' + id).then(r => r.data),
  getForRecord: (recordId) => api.get('/tags/record/' + recordId).then(r => r.data),
  addToRecord: (recordId, tagId) => api.post('/tags/record/' + recordId, { tag_id: tagId }).then(r => r.data),
  removeFromRecord: (recordId, tagId) => api.delete('/tags/record/' + recordId + '/' + tagId).then(r => r.data),
};
